import React, { Component } from 'react'
import './sessions.css'
import { confirmAlert } from 'react-confirm-alert'

export default class PeerToPeerDetail extends Component {
  constructor(props) {
    super(props)
  }

  getPeerToPeerStatus() {
    if(this.props.peerToPeer.id == null && this.props.peerToPeer.opted_out == false) {
      return 'no_meeting_scheduled'
    } else if(this.props.peerToPeer.id == null && this.props.peerToPeer.opted_out == true) {
      return 'timeslot_blocked'
    } else {
      return 'meeting'
    }
  }

  showHorizontalRule() {
    if(this.props.num > 0) {
      return(<hr/>)
    } else{
      return(null)
    }
  }

  showPeerToPeerDetails() {
    if(this.getPeerToPeerStatus() == 'no_meeting_scheduled') {
      return (
        <div className="peer-to-peer-container">
          <div>
            <h6 className="peer-to-peer-title">{this.props.peerToPeer.time_block_formatted_start_time}</h6>
            <p className="peer-to-peer-location">TBD</p>
          </div>
        </div>
      )
    } else if (this.getPeerToPeerStatus() == 'timeslot_blocked') {
      return (
        <div className="peer-to-peer-container">
          <div>
            <h6 className="peer-to-peer-title">{this.props.peerToPeer.time_block_formatted_start_time}</h6>
            <p className="peer-to-peer-location">Time slot is blocked.</p>
          </div>
        </div>
      )
    } else {
      return (
        <div className="peer-to-peer-container">
          <div>
            <h6 className="peer-to-peer-title">{this.props.peerToPeer.time_block_formatted_start_time}{this.userOrHiddenUser()}</h6>
            {/* <p className="peer-to-peer-location">{this.getLocation()}</p> */}
          </div>
          <div>
            {this.p2pMeetingAction()}
          </div>
        </div>
      )
    }
  }

  p2pMeetingAction() {
    if (this.props.peerToPeer.id) {
      if (this.props.peerToPeer.evaluation_completed) {
        return (
          <div key={this.props.peerToPeer.id}>
            <div><i className="float-right fa fa-check-circle taken-icon"></i></div>
          </div>
        )
      }
      // Eval Button should display once the meeting is past
      if (!this.props.peerToPeer.evaluation_completed && this.props.peerToPeer.epoch_start_time - Math.floor(new Date().getTime() / 1000) < 0) {
        return (
          <button onClick={() => this.props.history.push('/one_on_one_session_evaluation/' + this.props.peerToPeer.event_session_id + '/one_on_one_meeting_id/' + this.props.peerToPeer.id)}className="submit-button" >Take Eval</button>
        )
      }
      if (!this.props.peerToPeer.opted_out && this.props.peerToPeer.epoch_start_time - Math.floor(new Date().getTime() / 1000) > 0) {
        return (
          <button onClick={() => this.cancelPeerToPeer()}className="cancel-button" >Cancel Meeting</button>
        )
      }
    }
  }

  getLocation() {
    if (this.props.peerToPeer.meeting_location == undefined) {
      return ''
    } else {
      return 'Table ' + this.props.peerToPeer.meeting_location
    }
  }

  userOrHiddenUser() {
    let p2p = this.props.peerToPeer
    const users = JSON.parse(localStorage.getItem('users')).event_users
    var otherUser = users?.find((user) => {
      return user?.user_id === p2p?.participant_user?.id
    })
    return otherUser ? ` - ${otherUser.first_name} ${otherUser.last_name}, ${otherUser.organization_name}` : ' - Please see staff member'
  }

  cancelPeerToPeer() {
    confirmAlert({
      title: 'Cancel Peer-to-Peer Meeting',
      message: `Are you sure you want to cancel this meeting? The meeting will be removed for you and ${this.props.peerToPeer.participant_user.full_name}. This meeting time will also be blocked from your schedule.`,
      buttons: [
        {
          label: 'Cancel',
        },
        { label: 'Confirm',
          onClick: () => {this.handleCancelPeerToPeer()},
          className: 'solar-button'
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    })
  }

  handleCancelPeerToPeer() {
    window.api.delete(`/app/event_one_on_one_meetings/${this.props.peerToPeer.id}`).then(() => {
      // reach out to parent component and delete this from state
      this.props.handleBlockP2P(this.props.peerToPeer.id)
    })
  }

  render() {
    return (
      <div>
        { this.showHorizontalRule() }
        <div className='container'>
          <div className='row session'>
            { this.showPeerToPeerDetails() }
          </div>
        </div>
      </div>
    )
  }
}
